import React from "react";
import { Button } from "@mui/material";

export function MenuButtonPageBreak({ editor, t }) {
    return (
        <Button
            size="small"
            variant="outlined"
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => editor?.chain().focus().insertPageBreak().run()}
            disabled={!editor}
        >
            {t("insertNewPageAtCursor")}
        </Button>
    );
}
